/**
 *  Root script file
**/

import { MODULE_NAME, MUTATIONS } from '@/store/filters'
import {
  MODULE_NAME as MODULE_NAME_SITE,
  ACTIONS as ACTIONS_SITE,
  GETTERS as GETTERS_SITE
} from '@/store/site/constants'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import dashboardService from '@/api/dashboardService'

export default {
  name: 'Root',
  mixins: [],
  components: {
    Header: () => import(/* webpackChunkName: "Header" */ '@/components/header/Header.vue'),
    Sidebar: () => import(/* webpackChunkName: "Sidebar" */ '@/components/sidebar/Sidebar.vue'),
    BillingNotifycation: () => import(/* webpackChunkName: "BillingNotifycation" */'@/components/billing-notification/BillingNotification.vue')
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(MODULE_NAME_SITE, {
      openNotification: GETTERS_SITE.GET_BILLING_NOTIFICATION
    }),
    hasFooter () {
      return !this.$route.matched.some(m => m.meta.noFooter)
    },
    hasHeader () {
      return !this.$route.matched.some(m => m.meta.noHeader)
    },
    hasSidebar () {
      return !this.$route.matched.some(m => m.meta.noSidebar)
    },
    filterGroups () {
      const route = this.$route.matched.find(m => m.meta.filterGroups)
      return route && route.meta.filterGroups
    }
  },
  async mounted () {
    const billingState = await dashboardService.getCampaignsBillingState()
    this[ACTIONS_SITE.SET_BILLING_NOTIFICATION]({ payload: !billingState.state })
  },
  watch: {
    filterGroups: {
      immediate: true,
      handler (value) {
        this[MUTATIONS.SET_ACTIVE_GROUPS](value)
      }
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME, [MUTATIONS.SET_ACTIVE_GROUPS]),
    ...mapActions(MODULE_NAME_SITE, [ACTIONS_SITE.SET_BILLING_NOTIFICATION]),
    closeNotification () {
      this[ACTIONS_SITE.SET_BILLING_NOTIFICATION]({ payload: false })
    }
  }
}
